export const APISERVERURL='https://api.registrationappbu.nirupan.org'
//export const APISERVERURL='http://localhost:5444'
